import script from "./RequestStatus.vue?vue&type=script&setup=true&lang=ts"
export * from "./RequestStatus.vue?vue&type=script&setup=true&lang=ts"

import "./RequestStatus.vue?vue&type=style&index=0&id=5468d8c1&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5468d8c1"]])

export default __exports__